import {getMSData, postMSRequest, getExternalUrlData} from "../../../network/http/ms";
import { S3_LINK_THEME,S3_LINK_ASSETS } from "Utils/Constants";
import { setTableAssets } from "View/helper";

export const SET_LOGIN_STATUS = "setLoginStatus";
export const SET_LOGIN_TOKEN = "setLoginToken";
export const SET_CONNECTION_STATUS = "setConnectionStatus";
export const SET_NEW_CONNECTION_DETECTED = "setNewConnectionDetected";
export const SET_NETWORK_STRENGTH = "setNetworkStrength";
export const TOGGLE_NETWORK_LOADER = "toggleNetworkLoader";
export const TOGGLE_ADS_POPUP = "toggleAdsPopup";
export const SET_HELPDESK_POPUP ="toggleHelpDeskRefer";
export const TOGGLE_TRANSFER_POPUP = "toggleTransferPopup";
export const SET_DEEPLINK_URL = "setDeepLinkUrl";

export function toggleTransferPopup(payload){
    return {
        type: TOGGLE_TRANSFER_POPUP,
        payload: payload
    }
}

export function setConnectionStatus(isConnected) {
    return {
        type: SET_CONNECTION_STATUS,
        payload: isConnected
    }
}

export function setNewConnectionDetected(bool) {
    return {
        type: SET_NEW_CONNECTION_DETECTED,
        payload: bool
    }
}

export function toggleHelpDeskRefer(payload) {
    return {
        type : SET_HELPDESK_POPUP,
        payload
    }
}

export function setNetworkStrength(strength) {
    return {
        type: SET_NETWORK_STRENGTH,
        payload: strength
    }
}

export function toggleNetworkLoader(bool) {
    return {
        type: TOGGLE_NETWORK_LOADER,
        payload: bool
    }
}

export function toggleAdsPopup(bool) {
    return {
        type: TOGGLE_ADS_POPUP,
        payload: bool
    }
}

export function changeAuthState(authState) {
    return {
        type: SET_LOGIN_STATUS,
        payload: authState
    }
}

export function setLoginToken(loginToken) {
    return {
        type: SET_LOGIN_TOKEN,
        payload: loginToken
    }
}

export function getNewToken(success, error) {
    return (dispatch, getState) => {
        postMSRequest('refresh_token', {}, getState()['loginToken'], success, error);
    }
}

export function getAppConfig(callBack){
    getMSData("game_config",{"game":"poker"}, "", callBack, "")
} 

export function getThemeFile(callBack){
    getExternalUrlData( S3_LINK_THEME, callBack, "")
}

export function getImagesFile(callBack){
    getExternalUrlData(S3_LINK_ASSETS, callBack, "")
}

export function getTableAssets(){
    getMSData("all_app_assets",{"game":"poker"}, "", (response)=>{
        setTableAssets(response);
    });
}

export function setDeeplinkUrl(payload) {
  return {
    type: SET_DEEPLINK_URL,
    payload: payload,
  };
}